import React from "react"
import {
	EditButton,
	Show,
	SimpleShowLayout,
	Title,
	TopToolbar,
	useTranslate
} from "react-admin"

import EventStatistics from "./EventStatistics"

const Actions = () => <TopToolbar>
	<EditButton label="misc.edit" />
</TopToolbar>

const EventShow = () => {
	const translate = useTranslate()

	return (
		<Show
			actions={<Actions />}
		>
			<Title title={` - ${translate("resources.events.statistics.name")}`} />
			<SimpleShowLayout>
				<EventStatistics/>
			</SimpleShowLayout>
		</Show>
	)
}

export default EventShow
